import React from 'react';
import { Button, FadeIn } from './Shared';
export function Hero() {
  return <section className="relative pt-32 pb-20 md:pt-40 md:pb-32 px-6 md:px-12 lg:px-24 max-w-7xl mx-auto overflow-hidden" data-id="element-155">
      {/* Top: Eyebrow + H1 full width */}
      <div className="max-w-5xl mx-auto text-center mb-16" data-id="element-156">
        <FadeIn data-id="element-157">
          <span className="inline-block py-1 px-3 rounded-full bg-sage/10 text-sage font-medium text-sm tracking-wide uppercase mb-6" data-id="element-158">
            Free Recipe Guide
          </span>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-159">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight text-charcoal-dark" data-id="element-160">
            The 21-Day Keto Kitchen: Fast, Simple Recipes for Women 45+
          </h1>
        </FadeIn>
      </div>

      {/* Below: Two-column layout — image left, subhead + CTA right */}
      <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-161">
        {/* Left column — Image */}
        <div className="w-full lg:w-1/2 relative order-2 lg:order-1 flex justify-center" data-id="element-162">
          <FadeIn delay={0.2} className="relative w-full max-w-sm" data-id="element-163">
            <div className="relative rounded-2xl overflow-hidden aspect-square" data-id="element-164">
              <img src="https://cdn.magicpatterns.com/uploads/8DZhFF1jeweUiK5V9hx4Ax/The_21_day_keto_kitchen.png" alt="The 21-Day Keto Kitchen guide shown on a tablet in a bright kitchen" className="w-full h-full object-contain" data-id="element-165" />
            </div>

            {/* Decorative elements */}
            <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-terracotta/20 rounded-full blur-2xl -z-10" data-id="element-166"></div>
            <div className="absolute -top-6 -right-6 w-32 h-32 bg-sage/20 rounded-full blur-2xl -z-10" data-id="element-167"></div>
          </FadeIn>
        </div>

        {/* Right column — Subhead + Button + trust line */}
        <div className="w-full lg:w-1/2 flex flex-col items-start text-left z-10 order-1 lg:order-2" data-id="element-168">
          <FadeIn delay={0.3} data-id="element-169">
            <h2 className="text-2xl md:text-3xl font-serif font-medium text-charcoal leading-snug mb-10" data-id="element-170">
              Stop the guess-work and flip your metabolic switch with 21
              beginner-friendly, high-protein recipes designed to kill cravings
              and melt stubborn fat.
            </h2>
          </FadeIn>

          <FadeIn delay={0.4} className="w-full" data-id="element-171">
            <Button className="w-full sm:w-auto" data-id="element-172">
              Get the 21 Recipes for Free
            </Button>
            <p className="text-sm text-charcoal-light mt-4 font-medium" data-id="element-173">
              Join thousands of women who have simplified their weight loss
              journey.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}